import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'myabvv-allowances',
    standalone: true,
    templateUrl: './allowances.component.html',
    imports: [RouterOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AllowancesComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}
